<template>
  <div class="fixed absolute w-full bg-white h-12 px-4 flex items-center justify-between">
    <font-awesome-icon icon="bars" class="text-xl cursor-pointer z-30" @click="setShowSideBar(!showSideBar)"></font-awesome-icon>
    <div>
      <dropdown :label="userProfile.email" v-if="!userProfile.primer_nombre"></dropdown>
      <dropdown :label="userProfile.primer_nombre + ' ' + userProfile.primer_apellido" v-else></dropdown>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: "headercomponent",
  methods:{
    ...mapActions({
      setShowSideBar:'utils/setShowSideBar'
    })
  },
  computed:{
    ...mapGetters({
      showSideBar:'utils/getShowSideBar',
      userInfo:'getUserInfo',
      userProfile: 'getPerfilUsuario'
    })
  }
}
</script>

<style scoped>

</style>
